import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p452945073937645568',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
